import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap } from '@react-google-maps/api';
import MapMarkers from './MapMarkers';
import MapModal from './MapModal';
import ExpandMapButton from './ExpandMapButton';
import useMapInteraction from '@HotelSearchHooks/useMapInteraction';
import { MAP_ID_MAPS } from '@shared/conf/env';

const GoogleMapSection = ({
  mapCenter,
  isMobile,
  viewFullWidhtMap,
  hoveredHotel,
  setIsLoadImage,
  handleModal,
  showModal,
  hotel,
  handleCloseModal,
  handleChangePage,
  isLoadImage,
  handleMapFullWidth,
  allFilteredHotels,
  getFavConfig,
  getFormattedPrice,
  expandMap,
  mapTarget,
}) => {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  const hasIdFav = showModal && Object.hasOwn(hotel, 'id_fav_message');

  useMapInteraction({
    allFilteredHotels,
    mapRef,
    mapLoaded,
  });

  const mapOptions = {
    mapId: MAP_ID_MAPS,
    zoomControl: !isMobile,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUI: true,
    gestureHandling: isMobile ? 'cooperative' : 'greedy',
  };

  let mapHeight = '100vh';
  if (isMobile && !expandMap) {
    mapHeight = '50vh';
  }

  useEffect(() => {
    if (!mapLoaded || !mapRef.current || !mapTarget) return;
    const map = mapRef.current;

    map.panTo({
      lat: mapTarget.lat,
      lng: mapTarget.lng,
    });
    map.setZoom(19);
  }, [mapTarget, mapLoaded]);

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: mapHeight }}
      options={mapOptions}
      center={mapCenter}
      zoom={13}
      onLoad={map => {
        mapRef.current = map;
        setMapLoaded(true);
      }}
      onClick={handleCloseModal}
    >
      {mapLoaded && (
        <MapMarkers
          hotels={allFilteredHotels}
          hoveredHotel={hoveredHotel}
          setIsLoadImage={setIsLoadImage}
          handleModal={handleModal}
          getFormattedPrice={getFormattedPrice}
        />
      )}

      {showModal && (
        <MapModal
          hotel={hotel}
          getFavConfig={getFavConfig}
          viewFullWidhtMap={viewFullWidhtMap}
          handleCloseModal={handleCloseModal}
          handleChangePage={handleChangePage}
          hasIdFav={hasIdFav}
          isLoadImage={isLoadImage}
          setIsLoadImage={setIsLoadImage}
        />
      )}

      {!isMobile && (
        <ExpandMapButton
          expanded={viewFullWidhtMap}
          onToggle={handleMapFullWidth}
        />
      )}
    </GoogleMap>
  );
};

export default GoogleMapSection;
